import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { Search } from "lucide-react";
import React from "react";

interface SearchHeaderProps {
    searchPlaceholder?: string;
    onSearch: (value: string) => void;
    filters?: React.ReactNode;
    className?: string;
    value?: string;
}

export const SearchHeader: React.FC<SearchHeaderProps> = ({
    searchPlaceholder = "Пошук...",
    onSearch,
    filters,
    className,
    value,
}) => {
    return (
        <div className={cn("flex items-center gap-4 flex-wrap", className)}>
            <div className="flex-1 min-w-[200px] relative">
                <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
                <Input
                    placeholder={searchPlaceholder}
                    value={value}
                    onChange={(e) => onSearch(e.target.value)}
                    className="w-full pl-9"
                    type="search"
                />
            </div>
            {filters && <div className="flex items-center gap-2">{filters}</div>}
        </div>
    );
}; 